import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import Text from '@ff/ui/Text';
import Icon from '@ff/ui/Icon';
import { isAppOnly } from '~/app/utils/pathUtils';
import Link from '@ff/ui/Link';

export default function FFRobotPreorderLayout({children}: {children: React.ReactNode}){
  const isApp = isAppOnly();
  const location = useLocation();
  const { locale } = useParams<{ locale: string }>();

  // Check if we're on the FF Robot Preorder page (always use fixed header)
  const isFFRobotPreorderPage = location.pathname.includes('/preorder/robotics') || location.pathname.includes('/h5/ff-robotics-preorder');
  
  // Determine the correct logo link based on locale
  const logoLink = 'https://robotics.ff.com';
  // const logoLink = 'https://www.ff.com';

  return isApp
    ?
    <>
      <H5Header />
      <main>
        {children}
      </main>
    </>
    : 
    <>
      <HeaderContainer isFixed={isFFRobotPreorderPage}>
        <HeaderContent>
          <Link href={logoLink}>
            <LogoSection>
              <Icon name=" ff-icon-logo" fontSize="1.6rem" />
              <HeaderTitle>Home</HeaderTitle>
            </LogoSection>
          </Link>
        </HeaderContent>
      </HeaderContainer>
      <main style={{ backgroundColor: 'white' }}>
        {children}
      </main>
    </>
}

const H5Header = styled(Box)(({ theme }) => ({
  height: '46px',
  position: 'fixed',
  top: '0px',
  left: '0px',
  zIndex: theme.zIndices.menubar
}));

const HeaderContainer = styled(Box)<{ isFixed?: boolean }>(({ theme, isFixed }) => ({
  backgroundColor: '#fff',
  borderBottom: '1px solid #e5e7eb',
  padding: '0 16px',
  height: '54px',
  display: 'flex',
  alignItems: 'center',
  ...(isFixed && {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999, // Higher z-index to ensure it's above image carousel
  }),

  [theme.mediaQueries.md]: {
    padding: '0 24px',
  },
}));

const HeaderContent = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const LogoSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

const HeaderTitle = styled(Text)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: '600',
  color: '#1f2937',

  [theme.mediaQueries.md]: {
    fontSize: '18px',
  },
}));
